/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryResponse,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoPathParams,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo401,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo404,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo500,
} from "../../types/individualPaymentLookupsController/GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo } from "../../clients/individualPaymentLookupsController/getApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo.ts";

export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryKey =
  (
    courseFinancialId: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoPathParams["courseFinancialId"],
  ) =>
    [
      {
        url: "/api/v1/individualpayment/course-financials/:courseFinancialId/info",
        params: { courseFinancialId: courseFinancialId },
      },
    ] as const;

export type GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryKey =
  ReturnType<
    typeof getApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryKey
  >;

export function getApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryOptions(
  courseFinancialId: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoPathParams["courseFinancialId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryKey(
      courseFinancialId,
    );
  return queryOptions<
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo401
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo404
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo500
    >,
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryResponse,
    typeof queryKey
  >({
    enabled: !!courseFinancialId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo(
        courseFinancialId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Migrado do legado IndividualPayment/GetCourseFinancialInfo. **(Requer Authorization para autenticação)**
 * @summary Retorna totais e desconto de pontualidade do plano financeiro do curso (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/course-financials/:courseFinancialId/info}
 */
export function useGetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo<
  TData =
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryResponse,
  TQueryData =
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryKey,
>(
  courseFinancialId: GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoPathParams["courseFinancialId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo401
          | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo404
          | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryKey(
      courseFinancialId,
    );

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryOptions(
        courseFinancialId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo401
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo404
      | GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
